import React from 'react';
import Hero from 'components/hero';
import FeatureCard from 'components/feature-card';
import { ReactComponent as IconSaving } from 'svg/icons/saving.svg';
import { ReactComponent as IconWin } from 'svg/icons/win.svg';
import { ReactComponent as IconFreedom } from 'svg/icons/freedom.svg';
import { ReactComponent as Shape } from 'svg/shapes/shape_07.svg';
import './style.css';

const HomeBenefits = () => {
  return (
    <Hero layout="grid">
      <FeatureCard className="home-benefit-card">
        <div className="icon-shape">
          <IconSaving className="icon" />
          <Shape className="shape" />
        </div>
        <div className="content">
          <h3>Cost-effective</h3>
          <p>
            Giving Providers a simple and cost-effective solution and providing
            Workers with more control of their working life.
          </p>
        </div>
      </FeatureCard>

      <FeatureCard className="home-benefit-card">
        <div className="icon-shape">
          <IconWin className="icon" />
          <Shape className="shape" />
        </div>
        <div className="content">
          <h3>Win Win</h3>
          <p>
            MyShifts makes salary and fees more controllable - workers earn
            more, Providers don’t pay huge Agency fees. It’s a Win Win.
          </p>
        </div>
      </FeatureCard>

      <FeatureCard className="home-benefit-card">
        <div className="icon-shape">
          <IconFreedom className="icon" />
          <Shape className="shape" />
        </div>
        <div className="content">
          <h3>Freedom</h3>
          <p>
            Giving freedom of choice and control to Workers and reducing the
            stress of looking for temporary work.
          </p>
        </div>
      </FeatureCard>
    </Hero>
  );
};

export default HomeBenefits;
